// extracted by mini-css-extract-plugin
export var grid = "_28-0";
export var span1 = "_28-2";
export var span10 = "_28-b";
export var span10L = "_28-z";
export var span10M = "_28-n";
export var span10Xl = "_28-1b";
export var span11 = "_28-c";
export var span11L = "_28-10";
export var span11M = "_28-o";
export var span11Xl = "_28-1c";
export var span12 = "_28-d";
export var span12L = "_28-11";
export var span12M = "_28-p";
export var span12Xl = "_28-1d";
export var span1L = "_28-q";
export var span1M = "_28-e";
export var span1Xl = "_28-12";
export var span2 = "_28-3";
export var span2L = "_28-r";
export var span2M = "_28-f";
export var span2Xl = "_28-13";
export var span3 = "_28-4";
export var span3L = "_28-s";
export var span3M = "_28-g";
export var span3Xl = "_28-14";
export var span4 = "_28-5";
export var span4L = "_28-t";
export var span4M = "_28-h";
export var span4Xl = "_28-15";
export var span5 = "_28-6";
export var span5L = "_28-u";
export var span5M = "_28-i";
export var span5Xl = "_28-16";
export var span6 = "_28-7";
export var span6L = "_28-v";
export var span6M = "_28-j";
export var span6Xl = "_28-17";
export var span7 = "_28-8";
export var span7L = "_28-w";
export var span7M = "_28-k";
export var span7Xl = "_28-18";
export var span8 = "_28-9";
export var span8L = "_28-x";
export var span8M = "_28-l";
export var span8Xl = "_28-19";
export var span9 = "_28-a";
export var span9L = "_28-y";
export var span9M = "_28-m";
export var span9Xl = "_28-1a";
export var stretch = "_28-1";